import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpModule, Http} from '@angular/http';
import { HttpClient, HttpHeaders,HttpClientModule } from '@angular/common/http';

//Layout Modules
import { CommonLayoutComponent } from './common/common-layout.component';
import { AuthenticationLayoutComponent } from './common/authentication-layout.component';

//Directives
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Sidebar_Directives } from './shared/directives/side-nav.directive';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';



// Routing Module
import { AppRoutes } from './app.routing';

// App Component
import { AppComponent } from './app.component';
import { BranchComponent } from './branch/branch.component';
import { ClientsComponent } from './clients/clients.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import {SelectablesService} from './selectables.service';
import { RRFormComponent } from './r-r-form/r-r-form.component'

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RRFormService } from './r-r-form.service';
import { GatePassComponent } from './gate-pass/gate-pass.component';
import { GatePassService } from './gate-pass.service';
import { LRFormComponent } from './l-r-form/l-r-form.component';
import { LRFormService } from './l-r-form.service';
import { VoucherService } from './voucher.service';

import { DataTablesModule } from 'angular-datatables';
import {cardPortletDelete, cardPortletRefresh} from './shared/directives/cards.directive';
import { LRAcknowledgeComponent } from './l-r-acknowledge/l-r-acknowledge.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { AccessGuardService } from './_services/_auth/access-guard.service';
import { ConsignorComponent } from './masters/consignor/consignor.component';
import { ConsignorService } from './_services/_masters/consignor.service';
import { VehicleComponent } from './masters/vehicle/vehicle.component';
import { VehicleService } from './_services/_masters/vehicle.service';
import { TruckComponent } from './masters/truck/truck.component';
import { TruckService } from './_services/_masters/truck.service';
import { OnAccountComponent } from './masters/on-account/on-account.component';
import { OnAccountService } from './_services/_masters/on-account.service';
import { PartyComponent } from './masters/party/party.component';
import { PartyService } from './_services/_masters/party.service';
import { DestinationComponent } from './masters/destination/destination.component';
import { DestinationService } from './_services/_masters/destination.service';
import { ProductComponent } from './masters/product/product.component';
import { ProductService } from './_services/_masters/product.service';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { FreightMasterComponent } from './masters/freight-master/freight-master.component';
import { FreightMasterService } from './_services/_masters/freight-master.service';
import { GodownService } from './_services/_masters/godown.service';

import { InvoiceComponent } from './invoice/invoice.component';
import { DistrictComponent } from './masters/district/district.component';
import { DistrictService } from './_services/_masters/district.service';
import { BranchMasterComponent } from './masters/branch-master/branch-master.component';
import { BranchMasterService } from './_services/_masters/branch-master.service';
import { CookieService } from 'ngx-cookie-service';
import { LrFreightMasterComponent } from './masters/lr-freight-master/lr-freight-master.component';
import { TruckReportComponent } from './reports/truck-report/truck-report.component';
import { InvoiceReportComponent } from './reports/invoice-report/invoice-report.component';
import { AcknowledgeReportComponent } from './reports/acknowledge-report/acknowledge-report.component';
import { DispatchReportComponent } from './reports/dispatch-report/dispatch-report.component';
import { UsersComponent } from './users/users.component';
import { GodownComponent } from './masters/godown/godown.component';
import { EmailComponent } from './forgot-password/email/email.component';
import { VoucherComponent } from './voucher/voucher.component';

import { ForgotPasswordService } from './_services/forgot-password.service';
import { ResetPasswordComponent } from './forgot-password/reset-password/reset-password.component';
// Loader
import { NgxSpinnerModule } from 'ngx-spinner';

import {VoucherGuard} from './auth/voucher.guard';
import { VoucherReportComponent } from './reports/voucher-report/voucher-report.component';
import { DatePipe } from '@angular/common';




@NgModule({
	imports: [
		BrowserModule,
		HttpClientModule,
		HttpModule,
		DataTablesModule,
		ReactiveFormsModule,FormsModule,
		RouterModule.forRoot(AppRoutes),
		NgbModule.forRoot(),
		PerfectScrollbarModule,
		BsDatepickerModule.forRoot(),
		Ng2AutoCompleteModule,
		AngularMultiSelectModule,
		NgxSpinnerModule
	],
	declarations: [
		AppComponent,
		CommonLayoutComponent,
		AuthenticationLayoutComponent,
		Sidebar_Directives,
		BranchComponent,
		ClientsComponent,
		DashboardComponent,
		RRFormComponent,
		GatePassComponent,
		LRFormComponent, 
		cardPortletDelete, 
		cardPortletRefresh, 
		LRAcknowledgeComponent, 
		SignUpComponent, 
		SignInComponent, 
		ConsignorComponent, 
		VehicleComponent, 
		TruckComponent, 
		OnAccountComponent, 
		PartyComponent, 
		DestinationComponent, 
		ProductComponent, 
		FreightMasterComponent, 
		InvoiceComponent, 
		DistrictComponent, 
		BranchMasterComponent, 
		LrFreightMasterComponent, 
		TruckReportComponent, 
		InvoiceReportComponent, 
		AcknowledgeReportComponent, 
		DispatchReportComponent, 
		UsersComponent, 
		GodownComponent, 
		EmailComponent, 
		ResetPasswordComponent, 
		VoucherComponent, 
		VoucherReportComponent
	],
	providers: [
		SelectablesService, 
		HttpClientModule, 
		RRFormService, 
		GatePassService, 
		LRFormService, 
		AuthGuardService, 
		AccessGuardService,
		ConsignorService,
		TruckService,
		VehicleService,
		OnAccountService ,
		PartyService,
		DestinationService,
		ProductService ,
		FreightMasterService,
		BranchMasterService,
		DistrictService,
		CookieService,
		GodownService,
		ForgotPasswordService,
		VoucherService,
		VoucherGuard,
		DatePipe
	],
	bootstrap: [AppComponent]
})


export class AppModule { }



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/app.module.ts